// FRS 4.2.2 — Wizard สร้างเอกสาร ออพ.๐๑ + ออพ.๐๒ (Bundle)
// 4 ขั้น: (1) เลือกประเภท+เหตุผล (2) MANUAL (3) AUTO read-only (4) Preview+Submit
// รองรับ Revoke Pattern + Audit Log, Text Overflow Layer 1 (max_chars + counter)
//
// NOTE: ปิด a11y lint บางตัวสำหรับหน้านี้ (internal tool) — ความถูกต้อง a11y
// (label association / nav semantics / emoji) เป็นงาน hardening รอบถัดไป
/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control, jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/accessible-emoji */
import React from 'react';
import Layout from '../../components/layout/Layout';
import {
  listForms,
  createForm,
  getForm,
  getAutoData,
  getManualData,
  saveManualData,
  previewPdf,
  submitForm,
  revokeForm,
  getAuditLog,
  getRenderAudit,
} from '../../redux/forms/forms_actions';

// max_chars ต่อฟิลด์ (Layer 1) — ตรงกับ backend form_field_config.py
const LIMIT = {
  full_name: 80,
  id_card: 13,
  license_type: 60,
  license_level: 30,
  license_no: 60,
  cert_no: 60,
  phone: 10,
  construction_cost: 15,
  designer: 80,
  addr_house_no: 20,
  addr_moo: 3,
  addr_soi: 60,
  addr_road: 60,
  addr_sub_district: 50,
  addr_district: 50,
  addr_province: 30,
  addr_postal_code: 5,
};

const ADDRESS_FIELDS = [
  ['addr_house_no', 'เลขที่'],
  ['addr_moo', 'หมู่ที่'],
  ['addr_soi', 'ตรอก/ซอย'],
  ['addr_road', 'ถนน'],
  ['addr_sub_district', 'ตำบล/แขวง'],
  ['addr_district', 'อำเภอ/เขต'],
  ['addr_province', 'จังหวัด'],
  ['addr_postal_code', 'รหัสไปรษณีย์'],
];

const emptyAddr = () => ({
  addr_house_no: '',
  addr_moo: '',
  addr_soi: '',
  addr_road: '',
  addr_sub_district: '',
  addr_district: '',
  addr_province: '',
  addr_postal_code: '',
});

// input + char counter (Layer 1)
const CountedInput = ({ field, value, onChange, label, type = 'text', placeholder, hint }) => {
  const max = LIMIT[field];
  const len = (value || '').length;
  const over = max && len > max;
  return (
    <div style={{ marginBottom: 8 }}>
      {label && (
        <label style={{ display: 'block', fontSize: 13 }}>{label}</label>
      )}
      <input
        className="form-control"
        type={type}
        value={value || ''}
        maxLength={max}
        placeholder={placeholder}
        onChange={e => onChange(field, e.target.value)}
      />
      {hint && (
        <small style={{ display: 'block', color: '#888' }}>{hint}</small>
      )}
      {max && (
        <small style={{ color: over ? 'red' : '#888' }}>
          {len}/{max}
        </small>
      )}
    </div>
  );
};

// ใบประกอบวิชาชีพ — ตามกฎหมายมีค่าตายตัว (PM) → dropdown
const LICENSE_TYPES = ['วิศวกรรมควบคุม', 'สถาปัตยกรรมควบคุม'];
const LICENSE_LEVELS = ['ภาคีพิเศษ', 'ภาคี', 'สามัญ', 'วุฒิ']; // เรียงเล็ก→ใหญ่

const SelectInput = ({ field, value, onChange, label, options }) => (
  <div style={{ marginBottom: 8 }}>
    {label && <label style={{ display: 'block', fontSize: 13 }}>{label}</label>}
    <select
      className="form-control"
      value={value || ''}
      onChange={e => onChange(field, e.target.value)}
    >
      <option value="">— เลือก —</option>
      {options.map(o => (
        <option key={o} value={o}>
          {o}
        </option>
      ))}
    </select>
  </div>
);

class FormWizardPage extends React.Component {
  state = {
    projectId: null,
    forms: [],
    formId: null,
    form: null,
    step: 1,
    purpose: 'a1',
    inspector: {
      ...emptyAddr(),
      license_type: '',
      license_level: '',
      license_no: '',
      license_expire: '',
      cert_no: '',
      cert_expire: '',
      phone: '',
    },
    owner: { ...emptyAddr(), full_name: '', age: '', id_card: '', phone: '' },
    designer: '',
    construction_cost: '',
    // ออพ.๐๒ รูปแบบอาคาร/อุปกรณ์ — manual (default จากระบบ แก้ได้ขั้น 3) WWR ไม่อยู่ (AUTO)
    manual: {
      floor_height: '',
      wall: '',
      glass: '',
      roof: '',
      ac: '',
      lighting: '',
      hot_water: '',
    },
    auto: null,
    loadingAuto: false,
    autoError: null,
    previewUrl: null,
    auditLog: [],
    renderAudit: [],
    revokeReason: '',
    showRevoke: false,
    error: null,
    loading: false,
  };

  componentDidMount() {
    const projectId = this.props.match.params.projectId;
    this.setState({ projectId });
    this.refreshList(projectId);
  }

  refreshList = projectId => {
    listForms(projectId)
      .then(data => {
        // รองรับทุก shape: DatatablesPagination ({data}), DRF ({results}), array ตรง ๆ
        const list = Array.isArray(data)
          ? data
          : data.data || data.results || [];
        this.setState({ forms: list });
      })
      .catch(() => this.setState({ forms: [] }));
  };

  // ---- ขั้นที่ 1 ----
  handleCreate = () => {
    this.setState({ loading: true, error: null });
    createForm(this.state.projectId, this.state.purpose)
      .then(form => this.openForm(form.id))
      .catch(err => this.setState({ error: this.msg(err), loading: false }));
  };

  openForm = formId => {
    this.setState({ loading: true, formId });
    Promise.all([getForm(formId), getManualData(formId)])
      .then(([form, manual]) => {
        const p = manual.inspector_profile || {};
        const o = manual.building_owner || {};
        this.setState({
          form,
          step: 2,
          loading: false,
          purpose: form.purpose,
          designer: form.designer || '',
          construction_cost: form.construction_cost || '',
          inspector: { ...this.state.inspector, ...p },
          owner: { ...this.state.owner, ...o },
        });
      })
      .catch(err => this.setState({ error: this.msg(err), loading: false }));
  };

  // ---- ขั้นที่ 2: บันทึก MANUAL ----
  saveManual = nextStep => {
    const {
      formId,
      inspector,
      owner,
      designer,
      construction_cost,
      purpose,
    } = this.state;
    const payload = {
      purpose,
      designer,
      construction_cost: construction_cost || null,
      ...inspector,
      building_owner: owner,
    };
    this.setState({ loading: true, error: null });
    saveManualData(formId, payload)
      .then(() => {
        this.setState({ loading: false });
        this.goToStep(nextStep);
      })
      .catch(err => this.setState({ error: this.msg(err), loading: false }));
  };

  // ไปยัง step ที่ระบุ — โหลดข้อมูลของ step นั้นให้อัตโนมัติ (กันค้าง/ว่างเมื่อกดแท็บตรง ๆ)
  goToStep = step => {
    this.setState({ step });
    if (step === 3 && !this.state.auto) {
      this.loadAuto();
    }
    if (step === 4 && !this.state.previewUrl) {
      this.loadPreview();
    }
  };

  // ---- ขั้นที่ 3: โหลด AUTO จาก BEC engine ----
  loadAuto = () => {
    this.setState({ loadingAuto: true, autoError: null });
    getAutoData(this.state.formId)
      .then(auto => {
        // pre-fill manual: ค่าที่เคยบันทึกใน form ก่อน, ถ้าว่างใช้ default จากระบบ (AUTO)
        const f = this.state.form || {};
        const s = auto.structure || {};
        const p = auto.power || {};
        const manual = {
          floor_height: f.m_floor_height || s.floor_height || '',
          wall: f.m_wall_type || s.wall || '',
          glass: f.m_glass_type || s.glass || '',
          roof: f.m_roof_type || s.roof || '',
          ac: f.m_ac_type || p.ac || '',
          lighting: f.m_lighting_type || p.lighting || '',
          hot_water: f.m_hot_water_type || p.hot_water || '',
        };
        this.setState({ auto, manual, loadingAuto: false });
      })
      .catch(err =>
        this.setState({ autoError: this.msg(err), loadingAuto: false }),
      );
  };

  setManual = (field, v) =>
    this.setState({ manual: { ...this.state.manual, [field]: v } });

  // บันทึก manual (รูปแบบอาคาร/อุปกรณ์) แล้วไป Preview
  saveStructureAndPreview = () => {
    const m = this.state.manual;
    const payload = {
      m_floor_height: m.floor_height,
      m_wall_type: m.wall,
      m_glass_type: m.glass,
      m_roof_type: m.roof,
      m_ac_type: m.ac,
      m_lighting_type: m.lighting,
      m_hot_water_type: m.hot_water,
    };
    this.setState({ loading: true, error: null });
    saveManualData(this.state.formId, payload)
      .then(() => this.loadPreview())
      .catch(err => this.setState({ error: this.msg(err), loading: false }));
  };

  // อ่านข้อความ error — รองรับกรณี response เป็น Blob (จาก preview ที่ขอแบบ blob)
  extractError = (err, cb) => {
    const data = err && err.response && err.response.data;
    if (typeof Blob !== 'undefined' && data instanceof Blob) {
      data
        .text()
        .then(t => {
          try {
            cb(JSON.parse(t).detail || t);
          } catch (e) {
            cb(t);
          }
        })
        .catch(() => cb('เกิดข้อผิดพลาด'));
    } else {
      cb(this.msg(err));
    }
  };

  // ---- ขั้นที่ 4: Preview ----
  loadPreview = () => {
    const { formId } = this.state;
    this.setState({ loading: true, error: null, step: 4 });
    Promise.all([previewPdf(formId), getRenderAudit(formId)])
      .then(([url, renderAudit]) =>
        this.setState({ previewUrl: url, renderAudit, loading: false }),
      )
      .catch(err =>
        this.extractError(err, m =>
          this.setState({ error: m, loading: false }),
        ),
      );
  };

  handleSubmit = () => {
    const flagged = this.state.renderAudit.filter(a => a.was_flagged).length;
    if (
      flagged > 0 &&
      !window.confirm(
        `มี ${flagged} ฟิลด์ที่ระบบย่อ/ตัดข้อความให้พอดี — ยืนยันส่งตรวจ?`,
      )
    ) {
      return;
    }
    this.setState({ loading: true, error: null });
    submitForm(this.state.formId)
      .then(form => {
        this.setState({ form, loading: false });
        this.refreshList(this.state.projectId);
        this.loadAudit();
      })
      .catch(err => this.setState({ error: this.msg(err), loading: false }));
  };

  handleRevoke = () => {
    if (!this.state.revokeReason) {
      this.setState({ error: 'ต้องระบุเหตุผลในการถอนการส่งตรวจ' });
      return;
    }
    this.setState({ loading: true, error: null });
    revokeForm(this.state.formId, this.state.revokeReason)
      .then(form => {
        this.setState({
          form,
          showRevoke: false,
          revokeReason: '',
          loading: false,
        });
        this.loadAudit();
      })
      .catch(err => this.setState({ error: this.msg(err), loading: false }));
  };

  loadAudit = () => {
    getAuditLog(this.state.formId)
      .then(auditLog => this.setState({ auditLog }))
      .catch(() => {});
  };

  msg = err => (err && (err.detail || JSON.stringify(err))) || 'เกิดข้อผิดพลาด';

  setInspector = (f, v) =>
    this.setState({ inspector: { ...this.state.inspector, [f]: v } });
  setOwner = (f, v) =>
    this.setState({ owner: { ...this.state.owner, [f]: v } });

  render() {
    const { step, form, error, loading } = this.state;
    const locked = form && form.status === 'locked';
    const breadcrumbItems = [
      { name: 'โครงการ', path: '/projects' },
      { name: 'ออพ.๐๑ / ออพ.๐๒', path: '/id' },
    ];
    return (
      <Layout history={this.props.history} breadcrumbItems={breadcrumbItems}>
        <div style={{ padding: 24, maxWidth: 1000, margin: '0 auto' }}>
          <h2>เอกสาร ออพ.๐๑ / ออพ.๐๒</h2>
          {error && <div className="alert alert-danger">{error}</div>}
          {loading && <div className="alert alert-info">กำลังดำเนินการ...</div>}

          {!this.state.formId && this.renderListAndCreate()}
          {this.state.formId && (
            <div>
              {this.renderStepNav()}
              {step === 1 && this.renderStep1()}
              {step === 2 && this.renderStep2()}
              {step === 3 && this.renderStep3()}
              {step === 4 && this.renderStep4(locked)}
            </div>
          )}
        </div>
      </Layout>
    );
  }

  renderListAndCreate() {
    return (
      <div>
        <div className="panel panel-default" style={{ padding: 16 }}>
          <h4>สร้างเอกสารใหม่ (Bundle: ออพ.๐๑ + ออพ.๐๒)</h4>
          <label>
            <input
              type="radio"
              name="purpose"
              checked={this.state.purpose === 'a1'}
              onChange={() => this.setState({ purpose: 'a1' })}
            />{' '}
            ขอรับใบอนุญาตก่อสร้าง/ดัดแปลง
          </label>
          <br />
          <label>
            <input
              type="radio"
              name="purpose"
              checked={this.state.purpose === 'a5'}
              onChange={() => this.setState({ purpose: 'a5' })}
            />{' '}
            ขอรับใบรับรองการก่อสร้าง/ดัดแปลง
          </label>
          <br />
          <button
            className="btn btn-primary"
            onClick={this.handleCreate}
            style={{ marginTop: 8 }}
          >
            + สร้างเอกสาร
          </button>
        </div>
        <h4>เอกสารที่มีอยู่</h4>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>เลขที่</th>
              <th>Rev</th>
              <th>สถานะ</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {this.state.forms.map(f => (
              <tr key={f.id}>
                <td>{f.doc_number || '(ยังไม่ส่งตรวจ)'}</td>
                <td>{f.revision_no}</td>
                <td>{f.status === 'locked' ? '🔒 locked' : '📝 draft'}</td>
                <td>
                  <button
                    className="btn btn-link"
                    onClick={() => this.openForm(f.id)}
                  >
                    เปิด
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderStepNav() {
    const steps = [
      '1. ประเภท',
      '2. ข้อมูลผู้ใช้',
      '3. ข้อมูลระบบ (AUTO)',
      '4. Preview + ส่งตรวจ',
    ];
    return (
      <ul className="nav nav-pills" style={{ marginBottom: 16 }}>
        {steps.map((label, i) => (
          <li key={i} className={this.state.step === i + 1 ? 'active' : ''}>
            <a
              onClick={() => this.goToStep(i + 1)}
              style={{ cursor: 'pointer' }}
            >
              {label}
            </a>
          </li>
        ))}
        <li style={{ marginLeft: 'auto' }}>
          <a
            onClick={() => this.setState({ formId: null, form: null, step: 1 })}
            style={{ cursor: 'pointer' }}
          >
            ← กลับรายการ
          </a>
        </li>
      </ul>
    );
  }

  renderStep1() {
    return (
      <div>
        <h4>ประเภทเอกสาร: Bundle (ออพ.๐๑ + ออพ.๐๒) — สร้างคู่กันเสมอ</h4>
        <label>
          <input
            type="radio"
            checked={this.state.purpose === 'a1'}
            onChange={() => this.setState({ purpose: 'a1' })}
          />{' '}
          ขอรับใบอนุญาตก่อสร้าง/ดัดแปลง (อ.๑)
        </label>
        <br />
        <label>
          <input
            type="radio"
            checked={this.state.purpose === 'a5'}
            onChange={() => this.setState({ purpose: 'a5' })}
          />{' '}
          ขอรับใบรับรองการก่อสร้าง/ดัดแปลง (อ.๕)
        </label>
        <br />
        <button className="btn btn-primary" onClick={() => this.saveManual(2)}>
          ถัดไป →
        </button>
      </div>
    );
  }

  renderAddress(obj, setter, title) {
    return (
      <div style={{ marginBottom: 12 }}>
        <div style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 6 }}>
          {title} (ที่อยู่ 8 ช่อง)
        </div>
        <div
          style={{
            border: '1px solid #ddd',
            borderRadius: 4,
            padding: 12,
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 12,
          }}
        >
          {ADDRESS_FIELDS.map(([f, label]) => (
            <CountedInput
              key={f}
              field={f}
              label={label}
              value={obj[f]}
              onChange={setter}
            />
          ))}
        </div>
      </div>
    );
  }

  renderStep2() {
    const { inspector, owner } = this.state;
    return (
      <div>
        <h4>ผู้ตรวจประเมิน (Login user — ระบบ cache ค่าเดิมไว้)</h4>
        <SelectInput
          field="license_type"
          label="ใบประกอบวิชาชีพ (ประเภท)"
          value={inspector.license_type}
          options={LICENSE_TYPES}
          onChange={this.setInspector}
        />
        <SelectInput
          field="license_level"
          label="ระดับ"
          value={inspector.license_level}
          options={LICENSE_LEVELS}
          onChange={this.setInspector}
        />
        <CountedInput
          field="license_no"
          label="เลขทะเบียนใบประกอบวิชาชีพ"
          value={inspector.license_no}
          onChange={this.setInspector}
        />
        <div style={{ marginBottom: 8 }}>
          <label style={{ display: 'block', fontSize: 13 }}>
            วันหมดอายุใบประกอบวิชาชีพ
          </label>
          <input
            className="form-control"
            type="date"
            value={inspector.license_expire || ''}
            onChange={e => this.setInspector('license_expire', e.target.value)}
          />
        </div>
        <CountedInput
          field="cert_no"
          label="หนังสือรับรองผู้ตรวจประเมินเลขที่"
          value={inspector.cert_no}
          onChange={this.setInspector}
          placeholder="ผต.XXXX"
          hint="โปรดระบุ ผต. ตามด้วยเลข (เช่น ผต.1234)"
        />
        <div style={{ marginBottom: 8 }}>
          <label style={{ display: 'block', fontSize: 13 }}>
            วันหมดอายุหนังสือรับรองผู้ตรวจประเมิน
          </label>
          <input
            className="form-control"
            type="date"
            value={inspector.cert_expire || ''}
            onChange={e => this.setInspector('cert_expire', e.target.value)}
          />
        </div>
        <CountedInput
          field="phone"
          label="เบอร์โทรศัพท์ (ผู้ตรวจประเมิน)"
          value={inspector.phone}
          onChange={this.setInspector}
        />
        {this.renderAddress(
          inspector,
          this.setInspector,
          'ที่อยู่ผู้ตรวจประเมิน',
        )}
        <h4>เจ้าของอาคาร (กรอกใหม่ทุกฟอร์ม)</h4>
        <CountedInput
          field="full_name"
          label="ชื่อ / นิติบุคคล"
          value={owner.full_name}
          onChange={this.setOwner}
        />
        <div style={{ marginBottom: 8 }}>
          <label style={{ display: 'block', fontSize: 13 }}>อายุ</label>
          <input
            className="form-control"
            type="number"
            value={owner.age || ''}
            onChange={e => this.setOwner('age', e.target.value)}
            style={{ width: 120 }}
          />
        </div>
        <CountedInput
          field="id_card"
          label="เลขบัตรประชาชน (13 หลัก)"
          value={owner.id_card}
          onChange={this.setOwner}
        />
        <CountedInput
          field="phone"
          label="โทรศัพท์เจ้าของอาคาร"
          value={owner.phone}
          onChange={this.setOwner}
        />
        {this.renderAddress(owner, this.setOwner, 'ที่อยู่เจ้าของอาคาร')}
        <h4>อื่น ๆ</h4>
        <CountedInput
          field="designer"
          label="ผู้ออกแบบ (ออพ.๐๒)"
          value={this.state.designer}
          onChange={(f, v) => this.setState({ designer: v })}
        />
        <CountedInput
          field="construction_cost"
          label="ราคาค่าก่อสร้างรวม (บาท)"
          value={this.state.construction_cost}
          onChange={(f, v) => this.setState({ construction_cost: v })}
        />
        <button className="btn btn-default" onClick={() => this.saveManual(1)}>
          ← บันทึก/ย้อนกลับ
        </button>{' '}
        <button className="btn btn-primary" onClick={() => this.saveManual(3)}>
          บันทึก + ถัดไป →
        </button>
      </div>
    );
  }

  renderStep3() {
    const a = this.state.auto;
    if (this.state.loadingAuto) {
      return <div className="alert alert-info">กำลังโหลดข้อมูลระบบ...</div>;
    }
    if (this.state.autoError) {
      return (
        <div>
          <div className="alert alert-warning">
            ดึงข้อมูลระบบไม่ได้: {this.state.autoError}
            <br />
            <small>
              โครงการนี้อาจยังประเมินไม่ครบ (ไม่มีผล OTTV/SEER/E_total) —
              ฟอร์มต้องใช้โครงการที่ประเมินแล้ว
            </small>
          </div>
          <button className="btn btn-default" onClick={() => this.goToStep(2)}>
            ← กลับไปขั้น 2
          </button>{' '}
          <button className="btn btn-primary" onClick={this.loadAuto}>
            ลองใหม่
          </button>
        </div>
      );
    }
    if (!a) {
      return (
        <div>
          <p>ยังไม่ได้โหลดข้อมูลระบบ</p>
          <button className="btn btn-primary" onClick={this.loadAuto}>
            โหลดข้อมูลระบบ (AUTO)
          </button>
        </div>
      );
    }
    return (
      <div>
        <h4>ข้อมูลที่ระบบดึงอัตโนมัติ (AUTO — Read-only)</h4>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>ชื่อโครงการ/อาคาร</td>
              <td>{a.project_name}</td>
            </tr>
            <tr>
              <td>ประเภทอาคาร</td>
              <td>{a.building_type}</td>
            </tr>
            <tr>
              <td>สถานที่ตั้ง</td>
              <td>{a.building_location}</td>
            </tr>
            <tr>
              <td>พื้นที่อาคารทั้งหมด</td>
              <td>{a.area_detail && a.area_detail.total}</td>
            </tr>
            <tr>
              <td>ผ่านทุกรายระบบ</td>
              <td>{a.pass_all_systems ? '✓' : '-'}</td>
            </tr>
            <tr>
              <td>ผ่านรวมของอาคาร</td>
              <td>{a.pass_overall ? '✓' : '-'}</td>
            </tr>
          </tbody>
        </table>
        <h4 style={{ marginTop: 16 }}>
          รูปแบบอาคาร / อุปกรณ์ (ดึงค่าจากระบบเป็น default — แก้ไขได้)
        </h4>
        {this.renderManualField('จำนวนชั้น/ความสูง', 'floor_height')}
        {this.renderManualField('ชนิดและความหนาของผนัง', 'wall')}
        {this.renderManualField('ชนิดและความหนาของกระจก', 'glass')}
        <div style={{ marginBottom: 8 }}>
          <label style={{ display: 'block', fontSize: 13 }}>
            WWR A/C zone เฉลี่ย (%) — ดึงจากโปรแกรม (แก้ไม่ได้)
          </label>
          <input
            className="form-control"
            value={(a.structure && a.structure.wwr) || ''}
            readOnly
            style={{ background: '#eee' }}
          />
        </div>
        {this.renderManualField('ชนิดและความหนาของหลังคา', 'roof')}
        {this.renderManualField('ชนิดเครื่องปรับอากาศ', 'ac', 3)}
        {this.renderManualField('ชนิดอุปกรณ์ไฟฟ้าแสงสว่าง', 'lighting')}
        {this.renderManualField('ชนิดอุปกรณ์ผลิตน้ำร้อน', 'hot_water')}
        <h5 style={{ marginTop: 16 }}>ตาราง (๒) ผลการประเมิน</h5>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>เกณฑ์</th>
              <th>ค่ามาตรฐาน</th>
              <th>อาคารที่ออกแบบ</th>
              <th>ผล</th>
            </tr>
          </thead>
          <tbody>
            {(a.eval_rows || []).map((r, i) => (
              <tr key={i}>
                <td>{r.label}</td>
                <td>{r.ref}</td>
                <td>{r.value}</td>
                <td>{r.result}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <button
          className="btn btn-default"
          onClick={() => this.setState({ step: 2 })}
        >
          ← ย้อนกลับ
        </button>{' '}
        <button
          className="btn btn-primary"
          onClick={this.saveStructureAndPreview}
        >
          บันทึก + ไป Preview →
        </button>
      </div>
    );
  }

  // input manual ของรูปแบบอาคาร/อุปกรณ์ (textarea เผื่อข้อความยาว เช่น ชนิดแอร์)
  renderManualField(label, field, rows = 1) {
    return (
      <div style={{ marginBottom: 8 }}>
        <label style={{ display: 'block', fontSize: 13 }}>{label}</label>
        <textarea
          className="form-control"
          rows={rows}
          style={{ resize: 'vertical' }}
          value={this.state.manual[field] || ''}
          onChange={e => this.setManual(field, e.target.value)}
        />
      </div>
    );
  }

  renderStep4(locked) {
    const flagged = this.state.renderAudit.filter(a => a.was_flagged);
    return (
      <div>
        <h4>
          Preview (เฉพาะ 3 ไฟล์ที่ระบบสร้าง: ออพ.๐๑ + ออพ.๐๒ + แบบสรุปผล BEC)
        </h4>
        {flagged.length > 0 && (
          <div className="alert alert-warning">
            ⚠ มี {flagged.length} ฟิลด์ที่ font ถูกย่อ/ตัดให้พอดี:{' '}
            {flagged.map(f => f.field_key).join(', ')}
          </div>
        )}
        {this.state.loading && !this.state.previewUrl && (
          <div className="alert alert-info">กำลังสร้าง Preview...</div>
        )}
        {!this.state.loading && !this.state.previewUrl && (
          <button className="btn btn-primary" onClick={this.loadPreview}>
            โหลด Preview
          </button>
        )}
        {this.state.previewUrl && (
          <iframe
            title="preview"
            src={this.state.previewUrl}
            style={{ width: '100%', height: 600, border: '1px solid #ccc' }}
          />
        )}
        <div style={{ marginTop: 12 }}>
          {!locked && (
            <button className="btn btn-success" onClick={this.handleSubmit}>
              ส่งตรวจ (Submit) + สร้าง Bundle PDF
            </button>
          )}
          {locked && (
            <div>
              <div className="alert alert-success">
                🔒 เอกสารถูก lock แล้ว — เลขที่ {this.state.form.doc_number}{' '}
                (rev {this.state.form.revision_no})
                {this.state.form.bundle_file_url && (
                  <span>
                    {' '}
                    —{' '}
                    <a
                      href={this.state.form.bundle_file_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      ดาวน์โหลด Bundle PDF
                    </a>
                  </span>
                )}
              </div>
              <button
                className="btn btn-warning"
                onClick={() => this.setState({ showRevoke: true })}
              >
                ถอนการส่งตรวจ (Revoke)
              </button>
            </div>
          )}
        </div>

        {this.state.showRevoke && (
          <div
            className="panel panel-warning"
            style={{ padding: 12, marginTop: 12 }}
          >
            <p>⚠ เอกสารที่พิมพ์ออกไปแล้วอาจถูกใช้งานจริง โปรดยืนยันก่อนถอน</p>
            <textarea
              className="form-control"
              placeholder="ระบุเหตุผล (จำเป็น)"
              value={this.state.revokeReason}
              onChange={e => this.setState({ revokeReason: e.target.value })}
            />
            <button
              className="btn btn-danger"
              style={{ marginTop: 8 }}
              onClick={this.handleRevoke}
            >
              ยืนยันถอน
            </button>{' '}
            <button
              className="btn btn-default"
              style={{ marginTop: 8 }}
              onClick={() => this.setState({ showRevoke: false })}
            >
              ยกเลิก
            </button>
          </div>
        )}

        <h4 style={{ marginTop: 24 }}>ประวัติการส่งตรวจ / ถอน (Audit Log)</h4>
        <button className="btn btn-link" onClick={this.loadAudit}>
          โหลดประวัติ
        </button>
        <table className="table table-bordered table-condensed">
          <thead>
            <tr>
              <th>การกระทำ</th>
              <th>เวลา</th>
              <th>โดย</th>
              <th>Rev</th>
              <th>เหตุผล</th>
              <th>IP</th>
            </tr>
          </thead>
          <tbody>
            {this.state.auditLog.map(l => (
              <tr key={l.id}>
                <td>{l.action}</td>
                <td>{l.action_at}</td>
                <td>{l.action_by_name}</td>
                <td>{l.revision_no}</td>
                <td>{l.reason}</td>
                <td>{l.ip_address}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default FormWizardPage;



// WEBPACK FOOTER //
// ./src/pages/forms/FormWizardPage.js